import type { BriefTemplateContent } from '@fluenceur/types';
import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { compensationSummary } from './brief-content';
import { formatCents } from './format-money';

/** What a brief pays in a few words ("1 000 €", "Produit offert", "À définir"). */
export const briefCompensationSummary = (
  content: BriefTemplateContent,
  t: TFunction,
  language: string
): string =>
  compensationSummary(
    content,
    (amountCents, currency) => formatCents(amountCents, currency, language),
    t('collabs.briefTemplates.common.compensationToDefine'),
    t('collabs.briefTemplates.common.compensationGifted'),
    t('collabs.briefTemplates.common.compensationNone')
  );

/** `briefCompensationSummary` in the current language. */
export const useCompensationSummary = (content: BriefTemplateContent): string => {
  const { t, i18n } = useTranslation();
  return briefCompensationSummary(content, t, i18n.language);
};
